import { ShoppingCartIcon } from './Icons';
import './CartBadge.css';

interface Props {
  count: number;
  onClick: () => void;
}

export default function CartBadge({ count, onClick }: Props) {
  return (
    <button className="cart-badge" onClick={onClick} aria-label="Carrinho" type="button">
      <ShoppingCartIcon size={22} />
      {count > 0 && <span className="cart-badge-count">{count > 99 ? '99+' : count}</span>}
    </button>
  );
}
